import { render } from "./MembrosLista.vue?vue&type=template&id=0b70432a"
import script from "./MembrosLista.vue?vue&type=script&lang=js"
export * from "./MembrosLista.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__